import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'highlight'
})
export class HighlightPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  /**
   * Returns true if the string contains HTML markup.
   * Messages are either stored as HTML (links, attachment cards) or plain text.
   */
  private containsHtml(value: string): boolean {
    return /<[a-z][\s\S]*?>/i.test(value);
  }

  /**
   * Converts plain-text URLs into clickable <a> tags.
   * Only called when the message contains NO existing HTML.
   */
  private linkify(text: string): string {
    const urlRegex = /(https?:\/\/[^\s<>"']+)/gi;
    return text.replace(urlRegex, (url) => {
      const trimmed = url.replace(/[.,;:!?)]+$/, '');
      const trailing = url.slice(trimmed.length);
      return `<a href="${trimmed}" target="_blank" rel="noopener noreferrer" class="chat-link">${trimmed}</a>${trailing}`;
    });
  }

  transform(value: any, args: any): SafeHtml {
    if (!value) {
      return this.sanitizer.bypassSecurityTrustHtml('');
    }

    const str = String(value);

    // If the message already contains HTML (stored <a> links, attachment cards, etc.)
    // render it directly — no escaping needed as content is server-controlled.
    let html: string;
    if (this.containsHtml(str)) {
      html = str;
    } else {
      // Plain text message — linkify any URLs present
      html = this.linkify(str);
    }

    if (!args) {
      return this.sanitizer.bypassSecurityTrustHtml(html);
    }

    // Apply search highlight, but skip inside HTML tag attributes (e.g. href values)
    const escapedArgs = args.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const re = new RegExp(`(${escapedArgs})(?![^<]*>)`, 'gi');
    const result = html.replace(re, '<mark class="chat-search-highlight">$1</mark>');

    return this.sanitizer.bypassSecurityTrustHtml(result);
  }
}
